<script>
export default {
  name: "MglGeojsonLayer",
  inject: ["map"],
  props: {
    sourceId: {
      type: String,
      required: true,
    },
    source: {
      type: Object,
      required: true,
    },
    layerId: {
      type: String,
      required: true,
    },
    layer: {
      type: Object,
      required: true,
    },
    before: {
      type: String,
      default: undefined,
    },
  },
  render: (h) => h(),
  mounted() {
    this.$nextTick(() => {
      this.addLayer();
    });
  },
  methods: {
    addLayer() {
      if (!this.map) return;

      // Add source if it doesn't exist
      if (!this.map.getSource(this.sourceId)) {
        this.map.addSource(this.sourceId, {
          type: "geojson",
          data: this.source.data,
        });
      }

      // Add layer if it doesn't exist
      if (!this.map.getLayer(this.layerId)) {
        const layerDef = {
          ...this.layer,
          id: this.layerId,
          source: this.sourceId,
        };
        this.map.addLayer(layerDef, this.before);
      }
    },
    removeLayer() {
      if (!this.map) return;

      if (this.map.getLayer(this.layerId)) {
        this.map.removeLayer(this.layerId);
      }
      // Only remove source if no other layers use it
      if (this.map.getSource(this.sourceId)) {
        const style = this.map.getStyle();
        const layersUsingSource = style.layers.filter(
          (l) => l.source === this.sourceId
        );
        if (layersUsingSource.length === 0) {
          this.map.removeSource(this.sourceId);
        }
      }
    },
    updateSource() {
      if (!this.map) return;
      const src = this.map.getSource(this.sourceId);
      if (src && this.source && this.source.data) {
        src.setData(this.source.data);
      }
    },
  },
  watch: {
    source: {
      handler() {
        this.updateSource();
      },
      deep: true,
    },
    layer: {
      handler() {
        this.removeLayer();
        this.$nextTick(() => this.addLayer());
      },
      deep: true,
    },
  },
  beforeDestroy() {
    this.removeLayer();
  },
};
</script>
